import { Component, OnInit, inject } from '@angular/core';

import { DsButton } from '@frontend/ui/button';
import {
    ClientConfigProductName,
    ContentService,
    LoginNavigationService,
    NavigationService,
    ViewTemplateForClient,
    WINDOW,
} from '@frontend/vanilla/core';
import { HeaderBarComponent } from '@frontend/vanilla/features/header-bar';
import { first } from 'rxjs';

import { LoginDialogService } from '../login-dialog.service';

@Component({
    imports: [HeaderBarComponent, DsButton],
    providers: [LoginDialogService],
    selector: 'vn-pre-login-page',
    templateUrl: 'pre-login-page.html',
})
export class PreLoginPageComponent implements OnInit {
    private contentService = inject(ContentService);
    private loginDialogService = inject(LoginDialogService);
    private navigation = inject(NavigationService);
    private loginNavigation = inject(LoginNavigationService);

    item: ViewTemplateForClient;
    title: string;
    origin: string;
    private url: string;

    readonly #window = inject(WINDOW);

    ngOnInit() {
        // ensured by guard
        this.url = this.navigation.location.search.get('url')!;
        this.origin = this.navigation.location.search.get('origin')!;

        this.contentService
            .getJson('App-v1.0/PreLogin', { product: ClientConfigProductName.SF })
            .pipe(first())
            .subscribe((data: ViewTemplateForClient) => {
                this.item = data;
                this.title = this.item.messages![`Origin_Title_${this.origin}`]!;
            });
    }

    register() {
        this.loginNavigation.goToRegistration({ appendReferrer: this.url });
    }

    login() {
        this.loginDialogService.open({ returnUrl: this.url });
    }

    back() {
        this.#window.history.back();
    }
}
